import type { Customer } from '../schemas/customer.schema';

/** Внешний аккаунт заказчика не является сотрудником identity. */
export function canManageCustomers(roles: readonly string[] = []): boolean {
  return roles.includes('ADMIN') || roles.includes('MWS_ADMIN');
}

export interface CustomerProjectDto {
  id: number;
  project_no: string;
  name: string;
}

export type CustomerAdminDto = {
  id: number;
  name: string;
  email: string;
  isActive: boolean;
  projectIds: number[];
};

export interface SaveCustomerParams {
  id?: number;
  name: string;
  /** Только при создании; логин существующего заказчика здесь не меняется. */
  email?: string;
  password?: string;
  projectIds: number[];
}

export type CustomerListItem = Customer & CustomerAdminDto & { projectNumbers: string | null };
